import './ConfirmationScreen.scss';

import React, {ReactElement} from 'react';
import {Button} from "react-bootstrap";
import ArrowLeftIcon from "../icons/ArrowLeftIcon";
import {IconSize} from "../services/IconConstants";

interface Props {
    submitBtnText: string
    submitBtnClick: () => void
    heading: string
    subHeading?: string
    image: ReactElement
    children?: ReactElement
    goBack?: () => void
    hideButton?: boolean
}

const ConfirmationScreen = ({heading, image, submitBtnClick, submitBtnText, subHeading, children, goBack, hideButton = false}: Props) => {

    return (
        <div className={"confirmationScreen_container"}>
            {goBack && <div className={"confirmationScreen_goBack"} onClick={goBack}>
                <ArrowLeftIcon size={IconSize.xl}/>
            </div>}
            <div className={"confirmationScreen_imageAndHeadingsContainer"}>
                <div className={"confirmationScreen_imageContainer"}>
                    {image}
                </div>
                <span className={"confirmationScreen_heading"}>{heading}</span>
                {subHeading && <span className={"confirmationScreen_subHeading"}>{subHeading}</span>}
                {children && children}
            </div>
            <div>
                {!hideButton && <Button className={"confirmationScreen_btn"} onClick={submitBtnClick}>
                    <span className={"confirmationScreen_btnText"}>{submitBtnText}</span>
                </Button>}
            </div>
        </div>
    )
}

export default ConfirmationScreen;
